module.exports = __webpack_public_path__ + "img/zhuanli1.c7c5fcf.png";